import { render } from "./IconSuccessful.vue?vue&type=template&id=330c1409"
import script from "./IconSuccessful.vue?vue&type=script&lang=js"
export * from "./IconSuccessful.vue?vue&type=script&lang=js"
script.render = render

export default script